/* Teaching order of each day's vocabulary (verbs, nouns, adjectives, phrases; natural sequences kept). Keyed by level then day id. */
export const VOCAB_ORDER = {
 "A1": {
  "1": [
   "Meet",
   "Name",
   "Student",
   "Teacher",
   "Friend",
   "Nice",
   "I am",
   "You",
   "We",
   "Yes",
   "No",
   "Where",
   "From",
   "Hello",
   "Good morning",
   "Good evening",
   "Goodbye",
   "Please",
   "Thank you",
   "Sorry"
  ],
  "2": [
   "One / Two / Three",
   "Four",
   "Five",
   "Six",
   "Seven",
   "Eight",
   "Nine",
   "Ten",
   "Eleven",
   "Twelve",
   "Fifteen",
   "Twenty",
   "Thirty",
   "Age",
   "Year",
   "Brother",
   "Sister",
   "Old",
   "Young",
   "How old"
  ],
  "3": [
   "Red",
   "Blue",
   "Green",
   "White",
   "Black",
   "Yellow",
   "Orange",
   "Purple",
   "Big",
   "Small",
   "Tall",
   "Short",
   "New",
   "Old",
   "Hot",
   "Cold",
   "Happy",
   "Sad",
   "Beautiful",
   "Nice"
  ],
  "4": [
   "Mother",
   "Father",
   "Husband / Wife",
   "Brother",
   "Sister",
   "Family",
   "Kitchen",
   "Bathroom",
   "Garden",
   "Garage",
   "Balcony",
   "Stairs",
   "Floor",
   "Wall",
   "Ceiling",
   "Chair",
   "Table",
   "Lamp",
   "Sofa",
   "Key"
  ],
  "5": [
   "Wake up",
   "Eat breakfast",
   "Shower",
   "Go to school",
   "Cook",
   "Drink",
   "Breakfast",
   "Lunch",
   "Dinner",
   "Rice",
   "Bread",
   "Fruit",
   "Vegetable",
   "Restaurant",
   "Menu",
   "Hungry",
   "Thirsty",
   "Delicious",
   "Late",
   "Always"
  ],
  "6": [
   "Drive",
   "Walk",
   "Coffee",
   "Tea",
   "Sandwich",
   "Bus",
   "Train",
   "Taxi",
   "Bicycle",
   "Plane",
   "Airport",
   "Station",
   "Ticket",
   "Road",
   "Map",
   "Traffic",
   "Petrol",
   "Hungry",
   "Please",
   "How much"
  ],
  "7": [
   "Monday",
   "Tuesday",
   "Wednesday",
   "Thursday",
   "Friday",
   "Saturday",
   "Sunday",
   "Weekend",
   "Today",
   "Tomorrow",
   "Morning",
   "Afternoon",
   "Evening",
   "Night",
   "Hour",
   "Minute",
   "O'clock",
   "What time",
   "Early",
   "Late"
  ],
  "8": [
   "Pen",
   "Pencil",
   "Notebook",
   "Ruler",
   "Bag",
   "Board",
   "Classroom",
   "Library",
   "University",
   "Subject",
   "Lesson",
   "Homework",
   "Test",
   "Grade",
   "Season",
   "Sunny",
   "Rainy",
   "Hot",
   "Cold",
   "What's the weather like?"
  ],
  "9": [
   "Love",
   "Doctor",
   "Engineer",
   "Nurse",
   "Chef",
   "Parent",
   "Mother",
   "Father",
   "Grandmother",
   "Grandfather",
   "Son",
   "Daughter",
   "Uncle",
   "Aunt",
   "Cousin",
   "Husband",
   "Wife",
   "Baby",
   "What do you do?",
   "I work at / in"
  ],
  "10": [
   "Wear",
   "Shirt",
   "Trousers",
   "Dress",
   "Skirt",
   "Jacket",
   "Shoes",
   "Socks",
   "Hat",
   "Glasses",
   "Scarf",
   "Belt",
   "Colour",
   "Style",
   "Hospital",
   "Supermarket",
   "Bank",
   "Park",
   "Near / Far",
   "Is there a...?"
  ],
  "11": [
   "Try on",
   "Exchange",
   "Shirt",
   "Jacket",
   "Brand",
   "Size",
   "Price",
   "Sale",
   "Discount",
   "Receipt",
   "Credit card",
   "Cash",
   "Change",
   "Fitting room",
   "Queue",
   "Trolley",
   "Cheap",
   "Expensive",
   "Too expensive",
   "Fits well"
  ],
  "12": [
   "Order",
   "Menu",
   "Waiter / Waitress",
   "Bill",
   "Delicious",
   "Doctor",
   "Engineer",
   "Nurse",
   "Lawyer",
   "Accountant",
   "Pilot",
   "Chef",
   "Artist",
   "Journalist",
   "Manager",
   "Salary",
   "Office",
   "Career",
   "Experience",
   "For here or to go?"
  ],
  "13": [
   "Hurt / Pain",
   "Collect",
   "Relax",
   "Enjoy",
   "Head",
   "Stomach",
   "Fever",
   "Medicine",
   "Exercise",
   "Hobby",
   "Music",
   "Drawing",
   "Painting",
   "Photography",
   "Swimming",
   "Cooking",
   "Gardening",
   "Dancing",
   "Hiking",
   "Feel sick"
  ],
  "14": [
   "Check in",
   "Passport",
   "Flight",
   "Gate",
   "Luggage",
   "Boarding pass",
   "Season",
   "Climate",
   "Temperature",
   "Degree",
   "Forecast",
   "Umbrella",
   "Snow",
   "Storm",
   "Sunny",
   "Cloudy",
   "Windy",
   "Foggy",
   "Hot",
   "Cold"
  ],
  "15": [
   "Reading",
   "Swimming",
   "Cooking",
   "Park",
   "Museum",
   "Cinema",
   "Bank",
   "Pharmacy",
   "Hospital",
   "Post office",
   "Police station",
   "Mosque",
   "Church",
   "Supermarket",
   "Street",
   "Corner",
   "Directions",
   "I love / I like / I enjoy",
   "I don't like",
   "In my free time"
  ],
  "16": [
   "Understand",
   "Study",
   "Lesson / Class",
   "Homework",
   "Exam",
   "Headache",
   "Fever",
   "Cough",
   "Stomach ache",
   "Medicine",
   "Prescription",
   "Allergy",
   "Blood pressure",
   "X-ray",
   "Operation",
   "Ambulance",
   "Emergency",
   "Healthy",
   "Tired",
   "Can you repeat, please?"
  ],
  "17": [
   "Charge",
   "Download",
   "Upload",
   "Search",
   "Bedroom",
   "Kitchen",
   "Living room",
   "Furniture",
   "Email",
   "Password",
   "Website",
   "Application",
   "Message",
   "Screen",
   "Battery",
   "Printer",
   "Keyboard",
   "Camera",
   "Clean / Messy",
   "There is / There are"
  ],
  "18": [
   "Run",
   "Play",
   "Exercise",
   "Win / Lose",
   "Book",
   "Check in",
   "Football / Soccer",
   "Team",
   "Airport",
   "Hotel",
   "Passport",
   "Visa",
   "Luggage",
   "Tour",
   "Guide",
   "Reservation",
   "Currency",
   "Destination",
   "Souvenir",
   "Journey"
  ],
  "19": [
   "Agree",
   "Disagree",
   "Discuss",
   "Explain",
   "Understand",
   "Repeat",
   "Practise",
   "Improve",
   "Opinion",
   "Happy",
   "Sad",
   "Tired",
   "Excited",
   "Angry",
   "Confident",
   "Correct",
   "Wrong",
   "Slowly",
   "Clearly",
   "Why / Because"
  ],
  "20": [
   "January / February / March",
   "Birthday",
   "Save",
   "Spend",
   "Invest",
   "Afford",
   "Money",
   "Budget",
   "Bank account",
   "Loan",
   "Invoice",
   "Tax",
   "Profit",
   "Loss",
   "Insurance",
   "Rent",
   "When",
   "Next / Last",
   "In [month]",
   "Happy Birthday!"
  ],
  "21": [
   "Diagnose",
   "Rest",
   "Feel better",
   "Appointment",
   "Clinic",
   "Waiting room",
   "Patient",
   "Surgeon",
   "Symptom",
   "Fever",
   "Allergy",
   "Prescription",
   "Injection",
   "Bandage",
   "Blood test",
   "Recovery",
   "Pharmacy",
   "Insurance card",
   "Side effects",
   "How long have you had...?"
  ],
  "22": [
   "Bake",
   "Boil",
   "Fry",
   "Grill",
   "Cooking show",
   "Recipe",
   "Ingredient",
   "Spice",
   "Portion",
   "Corner",
   "Sweet",
   "Sour",
   "Salty",
   "Bitter",
   "Vegetarian",
   "Next to / Behind / In front of",
   "Turn left / right",
   "Go straight",
   "Excuse me",
   "You can't miss it!"
  ],
  "23": [
   "Get on / Get off",
   "Bus / Train / Taxi",
   "Ticket",
   "Station / Stop",
   "Novel",
   "Chapter",
   "Author",
   "Magazine",
   "Newspaper",
   "Dictionary",
   "Fiction",
   "Poetry",
   "Story",
   "Translation",
   "Sentence",
   "Paragraph",
   "Vocabulary",
   "Grammar",
   "Single / Return",
   "How long does it take?"
  ],
  "24": [
   "Recycle",
   "Plant",
   "Apple / Banana / Orange",
   "Kilo / Gram",
   "Change",
   "Environment",
   "Pollution",
   "Nature",
   "Forest",
   "Ocean",
   "Mountain",
   "Desert",
   "River",
   "Wildlife",
   "Solar energy",
   "Carbon",
   "Waste",
   "Fresh",
   "I need / Give me",
   "How much is...?"
  ],
  "25": [
   "Achieve",
   "Focus",
   "Plan",
   "Smartphone",
   "Charge / Battery",
   "App",
   "Message / Call",
   "Internet / Wi-Fi",
   "Download / Upload",
   "Dream",
   "Goal",
   "Success",
   "Failure",
   "Challenge",
   "Motivation",
   "Courage",
   "Patience",
   "Discipline",
   "Opportunity",
   "Progress"
  ],
  "26": [
   "Celebrate",
   "Welcome",
   "Cat / Dog",
   "Lion / Tiger",
   "Bird / Eagle",
   "Forest / Mountain",
   "Tradition",
   "Culture",
   "Festival",
   "Custom",
   "Heritage",
   "Ceremony",
   "Language",
   "Religion",
   "Respect",
   "Community",
   "Nationality",
   "Identity",
   "Wild / Domestic",
   "Beautiful / Dangerous"
  ],
  "27": [
   "Plan",
   "Go out",
   "Visit",
   "Movie",
   "Science",
   "Technology",
   "Research",
   "Experiment",
   "Theory",
   "Discovery",
   "Artificial intelligence",
   "Robot",
   "Satellite",
   "Space",
   "Data",
   "Software",
   "Innovation",
   "Programme",
   "I'm going to...",
   "Let's"
  ],
  "28": [
   "Communicate",
   "Interpret",
   "Hair",
   "Eyes",
   "Accent",
   "Slang",
   "Pronunciation",
   "Idiom",
   "Native speaker",
   "Translation",
   "Context",
   "Fluency",
   "Tall / Short",
   "Friendly / Kind",
   "Funny / Serious",
   "Fluent",
   "Formal",
   "Informal",
   "Bilingual",
   "He/She looks like..."
  ],
  "29": [
   "Celebrate",
   "Wish / Hope",
   "Trust",
   "Support",
   "Care",
   "Forgive",
   "Promise",
   "Communicate",
   "Compromise",
   "Gift / Present",
   "Party",
   "Relationship",
   "Argument",
   "Respect",
   "Honest",
   "Loyal",
   "Jealous",
   "Grateful",
   "Congratulations!",
   "Happy New Year / Eid Mubarak"
  ],
  "30": [
   "Achieve",
   "Continue",
   "Volunteer",
   "Inspire",
   "Progress",
   "Future",
   "Ambition",
   "Skill",
   "Career",
   "Scholarship",
   "Graduation",
   "Postgraduate",
   "Interview",
   "CV",
   "Promotion",
   "Leadership",
   "Network",
   "Confident",
   "Next level",
   "I can now..."
  ]
 },
 "A2": {
  "1": [
   "wake up",
   "shower",
   "brush",
   "cook",
   "exercise",
   "relax",
   "sleep",
   "alarm",
   "commute",
   "breakfast",
   "lunch",
   "dinner",
   "office",
   "meeting",
   "schedule",
   "routine",
   "weekend",
   "habit",
   "early",
   "late"
  ],
  "2": [
   "apartment",
   "living room",
   "bedroom",
   "kitchen",
   "bathroom",
   "balcony",
   "garage",
   "garden",
   "stairs",
   "ceiling",
   "floor",
   "window",
   "sofa",
   "shelf",
   "drawer",
   "mirror",
   "lamp",
   "curtains",
   "furniture",
   "neighbour"
  ],
  "3": [
   "supermarket",
   "trolley",
   "cashier",
   "queue",
   "receipt",
   "discount",
   "budget",
   "bread",
   "rice",
   "milk",
   "sugar",
   "apple",
   "vegetables",
   "cheese",
   "chicken",
   "bottle",
   "packet",
   "ingredient",
   "organic",
   "frozen"
  ],
  "4": [
   "sitting",
   "running",
   "talking",
   "listening",
   "writing",
   "reading",
   "cooking",
   "driving",
   "shopping",
   "waiting",
   "playing",
   "working",
   "watching",
   "eating",
   "drinking",
   "studying",
   "sleeping",
   "laughing",
   "crying",
   "smiling"
  ],
  "5": [
   "plan",
   "travel",
   "visit",
   "move",
   "start",
   "graduate",
   "save",
   "buy",
   "learn",
   "apply",
   "celebrate",
   "prepare",
   "change",
   "appointment",
   "project",
   "interview",
   "soon",
   "tonight",
   "next week",
   "next year"
  ],
  "6": [
   "yesterday",
   "last night",
   "last week",
   "ago",
   "visited",
   "cooked",
   "watched",
   "played",
   "worked",
   "cleaned",
   "walked",
   "talked",
   "waited",
   "opened",
   "closed",
   "started",
   "finished",
   "decided",
   "wanted",
   "enjoyed"
  ],
  "7": [
   "went",
   "came",
   "left",
   "ran",
   "saw",
   "heard",
   "took",
   "gave",
   "bought",
   "ate",
   "drank",
   "met",
   "told",
   "spoke",
   "wrote",
   "felt",
   "knew",
   "thought",
   "lost",
   "found"
  ],
  "8": [
   "me",
   "him",
   "her",
   "us",
   "them",
   "colleague",
   "classmate",
   "neighbour",
   "relative",
   "boss",
   "introduce",
   "invite",
   "remember",
   "forget",
   "support",
   "trust",
   "miss",
   "admire",
   "contact",
   "surprise"
  ],
  "9": [
   "bigger",
   "smaller",
   "taller",
   "shorter",
   "older",
   "younger",
   "heavier",
   "lighter",
   "faster",
   "slower",
   "cheaper",
   "more expensive",
   "better",
   "worse",
   "more comfortable",
   "noisier",
   "quieter",
   "healthier",
   "more popular",
   "further"
  ],
  "10": [
   "the biggest",
   "the smallest",
   "the tallest",
   "the oldest",
   "the youngest",
   "the fastest",
   "the hottest",
   "the coldest",
   "the best",
   "the worst",
   "the most beautiful",
   "the most delicious",
   "the most expensive",
   "the most popular",
   "the most crowded",
   "the friendliest",
   "the most difficult",
   "the easiest",
   "the most interesting",
   "the most important"
  ],
  "11": [
   "tried",
   "travelled",
   "met",
   "seen",
   "eaten",
   "won",
   "lost",
   "spoken",
   "written",
   "driven",
   "experience",
   "adventure",
   "dream",
   "achievement",
   "bucket list",
   "ever",
   "never",
   "already",
   "yet",
   "just"
  ],
  "12": [
   "suggest",
   "recommend",
   "improve",
   "practice",
   "can",
   "could",
   "should",
   "ability",
   "advice",
   "problem",
   "solution",
   "talent",
   "skill",
   "mistake",
   "effort",
   "goal",
   "confident",
   "nervous",
   "fluent",
   "patient"
  ],
  "13": [
   "register",
   "sign",
   "submit",
   "obey",
   "respect",
   "arrive",
   "permit",
   "must",
   "have to",
   "mustn't",
   "don't have to",
   "deadline",
   "uniform",
   "responsibility",
   "penalty",
   "allowed",
   "forbidden",
   "required",
   "necessary",
   "optional"
  ],
  "14": [
   "always",
   "usually",
   "often",
   "frequently",
   "regularly",
   "sometimes",
   "occasionally",
   "rarely",
   "hardly ever",
   "never",
   "from time to time",
   "every day",
   "once a week",
   "twice a month",
   "daily",
   "weekly",
   "monthly",
   "annually",
   "occasional",
   "habit"
  ],
  "15": [
   "at",
   "in",
   "on",
   "by",
   "near",
   "between",
   "opposite",
   "behind",
   "in front of",
   "above",
   "below",
   "along",
   "around",
   "inside",
   "outside",
   "corner",
   "entrance",
   "floor",
   "middle",
   "direction"
  ],
  "16": [
   "offer",
   "promise",
   "predict",
   "decide",
   "refuse",
   "mind",
   "support",
   "believe",
   "imagine",
   "change",
   "future",
   "technology",
   "opportunity",
   "doubt",
   "certain",
   "certainly",
   "probably",
   "maybe",
   "soon",
   "eventually"
  ],
  "17": [
   "because",
   "so",
   "since",
   "while",
   "although",
   "even though",
   "despite",
   "but",
   "however",
   "and",
   "or",
   "therefore",
   "unless",
   "in addition",
   "furthermore",
   "on the other hand",
   "as a result",
   "reason",
   "consequence",
   "contrast"
  ],
  "18": [
   "who",
   "what",
   "where",
   "when",
   "why",
   "how",
   "which",
   "whose",
   "how much",
   "how many",
   "how long",
   "how far",
   "how often",
   "what kind",
   "what time",
   "how old",
   "answer",
   "question",
   "interview",
   "response"
  ],
  "19": [
   "describe",
   "define",
   "identify",
   "belong",
   "refer",
   "person",
   "place",
   "object",
   "device",
   "tool",
   "situation",
   "personality",
   "appearance",
   "feature",
   "characteristic",
   "typical",
   "unique",
   "who",
   "which",
   "that"
  ],
  "20": [
   "happen",
   "cause",
   "pass",
   "fail",
   "imagine",
   "condition",
   "result",
   "effect",
   "consequence",
   "scenario",
   "situation",
   "weather",
   "opportunity",
   "possible",
   "likely",
   "real",
   "late",
   "if",
   "when",
   "unless"
  ],
  "21": [
   "built",
   "made",
   "produced",
   "invented",
   "discovered",
   "found",
   "sold",
   "delivered",
   "written",
   "spoken",
   "translated",
   "announced",
   "cancelled",
   "arrested",
   "opened",
   "closed",
   "damaged",
   "repaired",
   "painted",
   "by"
  ],
  "22": [
   "said",
   "told",
   "asked",
   "replied",
   "explained",
   "mentioned",
   "admitted",
   "promised",
   "complained",
   "suggested",
   "denied",
   "announced",
   "confirmed",
   "warned",
   "insisted",
   "wondered",
   "claim",
   "agree",
   "disagree",
   "inform"
  ],
  "23": [
   "get up",
   "wake up",
   "grow up",
   "go out",
   "come back",
   "go on",
   "carry on",
   "pick up",
   "bring up",
   "look up",
   "look after",
   "look forward to",
   "find out",
   "give up",
   "run out of",
   "set up",
   "turn on",
   "turn off",
   "put on",
   "take off"
  ],
  "24": [
   "afford",
   "manage",
   "quantity",
   "degree",
   "size",
   "weight",
   "speed",
   "noise",
   "space",
   "time",
   "energy",
   "experience",
   "patience",
   "balance",
   "pressure",
   "enough",
   "not enough",
   "too",
   "too much",
   "too many"
  ],
  "25": [
   "choose",
   "prefer",
   "agree",
   "vote",
   "option",
   "group",
   "both",
   "either",
   "neither",
   "all",
   "none",
   "each",
   "every",
   "some",
   "most",
   "few",
   "many",
   "similar",
   "different",
   "individual"
  ],
  "26": [
   "wish",
   "dream",
   "hope",
   "prefer",
   "achieve",
   "imagine",
   "desire",
   "request",
   "priority",
   "lifestyle",
   "career",
   "ambition",
   "choice",
   "future",
   "ideal",
   "polite",
   "comfortable",
   "would like",
   "would prefer",
   "rather"
  ],
  "27": [
   "continue",
   "progress",
   "change",
   "recently",
   "so far",
   "up to now",
   "finally",
   "at last",
   "once",
   "twice",
   "yesterday",
   "last year",
   "this week",
   "in 2022",
   "for",
   "since",
   "ago",
   "when",
   "how long",
   "at what time"
  ],
  "28": [
   "realise",
   "manage",
   "turn out",
   "accident",
   "adventure",
   "nervous",
   "excited",
   "embarrassed",
   "relieved",
   "memorable",
   "suddenly",
   "fortunately",
   "unfortunately",
   "once",
   "at first",
   "then",
   "after that",
   "in the end",
   "meanwhile",
   "finally"
  ],
  "29": [
   "recycle",
   "exercise",
   "health",
   "mental health",
   "environment",
   "pollution",
   "climate",
   "disease",
   "medicine",
   "screen",
   "social media",
   "technology",
   "stress",
   "waste",
   "solution",
   "impact",
   "renewable",
   "global",
   "local",
   "aware"
  ],
  "30": [
   "accomplish",
   "improve",
   "celebrate",
   "communicate",
   "express",
   "understand",
   "achieve",
   "practise",
   "grammar",
   "vocabulary",
   "review",
   "progress",
   "skill",
   "journal",
   "determination",
   "journey",
   "next level",
   "B1",
   "confident",
   "fluent"
  ]
 },
 "B1": {
  "1": [
   "accomplish",
   "abandon",
   "acquire",
   "obtain",
   "pursue",
   "acknowledge",
   "anticipate",
   "determine",
   "eliminate",
   "establish",
   "hesitate",
   "implement",
   "indicate",
   "resolve",
   "colleague",
   "consequence",
   "deadline",
   "impact",
   "evident",
   "genuine"
  ],
  "2": [
   "commit",
   "expand",
   "forecast",
   "predict",
   "guarantee",
   "negotiate",
   "ambition",
   "initiative",
   "intention",
   "outcome",
   "perspective",
   "potential",
   "priority",
   "progress",
   "prospect",
   "schedule",
   "strategy",
   "transition",
   "vision",
   "sustainable"
  ],
  "3": [
   "afford",
   "assume",
   "cope",
   "dedicate",
   "emphasise",
   "invest",
   "approach",
   "challenge",
   "dilemma",
   "hesitation",
   "hypothesis",
   "impulse",
   "scenario",
   "capable",
   "crucial",
   "flexible",
   "grateful",
   "rational",
   "reluctant",
   "worthwhile"
  ],
  "4": [
   "regret",
   "overlook",
   "persist",
   "intervene",
   "confront",
   "contribute",
   "delay",
   "foresee",
   "inspire",
   "launch",
   "negotiate",
   "overcome",
   "retrieve",
   "underestimate",
   "alternative",
   "consequence",
   "exception",
   "pressure",
   "desperate",
   "obvious"
  ],
  "5": [
   "assume",
   "confuse",
   "convince",
   "exhaust",
   "ignore",
   "investigate",
   "misunderstand",
   "panic",
   "reveal",
   "undermine",
   "vanish",
   "witness",
   "clue",
   "evidence",
   "disaster",
   "fault",
   "incident",
   "precaution",
   "suspicious",
   "thoroughly"
  ],
  "6": [
   "announce",
   "approve",
   "assess",
   "ban",
   "broadcast",
   "compile",
   "confirm",
   "damage",
   "distribute",
   "export",
   "fund",
   "generate",
   "instruct",
   "launch",
   "manufacture",
   "notify",
   "publish",
   "replace",
   "suspend",
   "allocate"
  ],
  "7": [
   "admit",
   "deny",
   "avoid",
   "concentrate",
   "consider",
   "delay",
   "discourage",
   "engage",
   "excel",
   "insist",
   "involve",
   "prevent",
   "succeed in",
   "feel like",
   "keen on",
   "look forward to",
   "familiar",
   "incapable",
   "despite",
   "instead of"
  ],
  "8": [
   "accomplish",
   "attempt",
   "claim",
   "enable",
   "expect",
   "hesitate",
   "manage",
   "motivate",
   "capacity",
   "objective",
   "adequate",
   "sufficient",
   "ambiguous",
   "competent",
   "complex",
   "critical",
   "determined",
   "fluent",
   "fundamental",
   "reluctant"
  ],
  "9": [
   "acknowledge",
   "attempt",
   "cease",
   "concern",
   "dread",
   "imply",
   "interrupt",
   "merit",
   "neglect",
   "recall",
   "incident",
   "nuance",
   "deliberate",
   "distinct",
   "former",
   "grateful",
   "persistent",
   "prompt",
   "subtle",
   "worthwhile"
  ],
  "10": [
   "accuse",
   "admit",
   "advise",
   "agree",
   "allege",
   "announce",
   "argue",
   "boast",
   "claim",
   "complain",
   "confirm",
   "deny",
   "emphasise",
   "instruct",
   "maintain",
   "persuade",
   "point out",
   "recommend",
   "reveal",
   "warn"
  ],
  "11": [
   "architect",
   "candidate",
   "colleague",
   "entrepreneur",
   "mentor",
   "delegate",
   "campaign",
   "initiative",
   "strategy",
   "infrastructure",
   "renovation",
   "manuscript",
   "decade",
   "deficit",
   "credentials",
   "coincidence",
   "phenomenon",
   "exhibit",
   "bilateral",
   "elaborate"
  ],
  "12": [
   "therefore",
   "consequently",
   "accordingly",
   "hence",
   "furthermore",
   "moreover",
   "subsequently",
   "meanwhile",
   "however",
   "nevertheless",
   "nonetheless",
   "albeit",
   "admittedly",
   "contrary",
   "conversely",
   "whereas",
   "despite",
   "in spite of",
   "in contrast",
   "on the other hand"
  ],
  "13": [
   "set up",
   "carry out",
   "bring about",
   "build on",
   "come up with",
   "deal with",
   "draw up",
   "follow up",
   "look into",
   "take on",
   "pull off",
   "make up for",
   "cut back on",
   "phase out",
   "lay off",
   "call off",
   "fall through",
   "back down",
   "come across",
   "run out of"
  ],
  "14": [
   "aspire",
   "distract",
   "hesitate",
   "invest",
   "sacrifice",
   "underestimate",
   "barrier",
   "confidence",
   "consequence",
   "fluency",
   "opportunity",
   "priority",
   "bitter",
   "committed",
   "complicated",
   "genuine",
   "grateful",
   "persistent",
   "realistic",
   "stubborn"
  ],
  "15": [
   "alter",
   "appraise",
   "audit",
   "calibrate",
   "clean",
   "decorate",
   "deliver",
   "diagnose",
   "dry-clean",
   "engrave",
   "examine",
   "frame",
   "install",
   "measure",
   "renew",
   "repair",
   "resize",
   "service",
   "translate",
   "certificate"
  ],
  "16": [
   "acknowledge",
   "contradict",
   "deliberately",
   "deny",
   "emphasise",
   "assertion",
   "insight",
   "absolute",
   "adamant",
   "bizarre",
   "compelling",
   "decisive",
   "drastic",
   "exceptional",
   "explicit",
   "extreme",
   "fundamental",
   "genuine",
   "paramount",
   "subtle"
  ],
  "17": [
   "accumulated",
   "circumstances",
   "commitment",
   "consequence",
   "crucial",
   "determination",
   "discipline",
   "experience",
   "foundation",
   "insight",
   "intersection",
   "mentor",
   "momentum",
   "opportunity",
   "perspective",
   "proactive",
   "resilience",
   "setback",
   "sustainable",
   "trajectory"
  ],
  "18": [
   "acknowledge",
   "analyse",
   "assess",
   "compile",
   "confirm",
   "convince",
   "dedicate",
   "discover",
   "examine",
   "exhaust",
   "express",
   "fund",
   "inspire",
   "investigate",
   "negotiate",
   "overwhelm",
   "publish",
   "resolve",
   "approach",
   "motivated"
  ],
  "19": [
   "collaborate",
   "delegate",
   "negotiate",
   "applicant",
   "appraisal",
   "benchmark",
   "burnout",
   "competence",
   "deadline",
   "initiative",
   "mentor",
   "networking",
   "objective",
   "probation",
   "redundancy",
   "resilience",
   "workload",
   "ambitious",
   "autonomous",
   "constructive"
  ],
  "20": [
   "regulate",
   "algorithm",
   "artificial intelligence",
   "automation",
   "connectivity",
   "cybersecurity",
   "data privacy",
   "privacy",
   "surveillance",
   "digital divide",
   "disinformation",
   "misinformation",
   "infrastructure",
   "innovation",
   "platform",
   "transparency",
   "virtual reality",
   "disruptive",
   "ethical",
   "sustainable"
  ],
  "21": [
   "climate change",
   "carbon footprint",
   "emissions",
   "fossil fuels",
   "pollution",
   "landfill",
   "recycling",
   "renewable energy",
   "solar panels",
   "net zero",
   "sea level",
   "deforestation",
   "reforestation",
   "biodiversity",
   "ecosystem",
   "habitat",
   "wildlife",
   "conservation",
   "sustainability",
   "urbanisation"
  ],
  "22": [
   "exercise",
   "diagnosis",
   "symptom",
   "prescription",
   "therapy",
   "vaccination",
   "prevention",
   "immune system",
   "mental health",
   "anxiety",
   "resilience",
   "wellbeing",
   "lifestyle",
   "nutrition",
   "hydration",
   "obesity",
   "screentime",
   "chronic",
   "sedentary",
   "holistic"
  ],
  "23": [
   "influence",
   "subvert",
   "critique",
   "documentary",
   "narrative",
   "portrayal",
   "representation",
   "satire",
   "censorship",
   "streaming",
   "medium",
   "heritage",
   "tradition",
   "perspective",
   "mainstream",
   "aesthetic",
   "authentic",
   "contemporary",
   "controversial",
   "universal"
  ],
  "24": [
   "verify",
   "experiment",
   "hypothesis",
   "methodology",
   "research",
   "data",
   "variable",
   "peer review",
   "clinical trial",
   "laboratory",
   "simulation",
   "prototype",
   "breakthrough",
   "innovation",
   "technology transfer",
   "genome",
   "stem cells",
   "robotics",
   "quantum",
   "empirical"
  ],
  "25": [
   "acclimatise",
   "emigrate",
   "immerse",
   "destination",
   "border",
   "visa",
   "migration",
   "refugee",
   "expatriate",
   "diaspora",
   "culture shock",
   "local customs",
   "overtourism",
   "sustainable tourism",
   "privilege",
   "worldview",
   "cosmopolitan",
   "ethnic",
   "open-minded",
   "infrastructure"
  ],
  "26": [
   "invest",
   "economy",
   "budget",
   "tax",
   "trade",
   "debt",
   "deficit",
   "interest rate",
   "inflation",
   "recession",
   "austerity",
   "GDP",
   "capitalism",
   "disposable income",
   "financial literacy",
   "poverty",
   "inequality",
   "wealth gap",
   "living wage",
   "universal basic income"
  ],
  "27": [
   "empower",
   "accountability",
   "advocacy",
   "bias",
   "discrimination",
   "justice",
   "equality",
   "equity",
   "inequality",
   "inclusion",
   "diversity",
   "civil rights",
   "human rights",
   "welfare",
   "solidarity",
   "privilege",
   "community",
   "grassroots",
   "marginalised",
   "systemic"
  ],
  "28": [
   "underpin",
   "dimension",
   "rhetoric",
   "scrutiny",
   "tension",
   "comprehensive",
   "dynamic",
   "fundamental",
   "implicit",
   "inherent",
   "nuanced",
   "profound",
   "robust",
   "subtle",
   "unprecedented",
   "viable",
   "albeit",
   "arguably",
   "explicitly",
   "insight"
  ],
  "29": [
   "acknowledge",
   "concede",
   "elaborate",
   "justify",
   "maintain",
   "qualify",
   "refute",
   "substantiate",
   "assertion",
   "counter-argument",
   "framework",
   "implication",
   "premise",
   "thesis",
   "coherent",
   "logical",
   "objective",
   "persuasive",
   "relevant",
   "subjective"
  ],
  "30": [
   "aspire",
   "consolidate",
   "accomplishment",
   "milestone",
   "commitment",
   "discipline",
   "exposure",
   "fluency",
   "immersion",
   "momentum",
   "perseverance",
   "proficiency",
   "reflection",
   "resilience",
   "trajectory",
   "benchmark",
   "autonomous",
   "dedicated",
   "gradual",
   "independent"
  ]
 },
 "B2": {
  "1": [
   "allege",
   "claim",
   "assert",
   "concede",
   "dispute",
   "refute",
   "disclose",
   "reveal",
   "report",
   "propose",
   "suggest",
   "imply",
   "infer",
   "presume",
   "speculate",
   "deem",
   "contemplate",
   "attribute",
   "establish",
   "verify"
  ],
  "2": [
   "stipulate",
   "trigger",
   "assumption",
   "premise",
   "criterion",
   "exception",
   "caveat",
   "circumstance",
   "implication",
   "provision",
   "scenario",
   "threshold",
   "variable",
   "counterfactual",
   "hypothetical",
   "contingent",
   "inevitable",
   "viable",
   "warranted",
   "unless"
  ],
  "3": [
   "abolition",
   "acknowledgement",
   "advancement",
   "allocation",
   "assertion",
   "consolidation",
   "deterioration",
   "discrepancy",
   "endorsement",
   "erosion",
   "implementation",
   "intervention",
   "manifestation",
   "proliferation",
   "ratification",
   "reconciliation",
   "reinforcement",
   "restructuring",
   "stabilisation",
   "transition"
  ],
  "4": [
   "digress",
   "exemplify",
   "caveat",
   "coherence",
   "cohesion",
   "connective",
   "contrast",
   "elaboration",
   "premises",
   "register",
   "albeit",
   "whilst",
   "whereby",
   "henceforth",
   "furthermore",
   "by the same token",
   "in lieu of",
   "inasmuch as",
   "insofar as",
   "notwithstanding"
  ],
  "5": [
   "be bound to",
   "be liable to",
   "be supposed to",
   "conjecture",
   "contingency",
   "epistemic",
   "deontic",
   "credible",
   "plausible",
   "implausible",
   "inconceivable",
   "inevitable",
   "warranted",
   "categorically",
   "conceivably",
   "presumably",
   "tentatively",
   "unquestionably",
   "in all likelihood",
   "in the event that"
  ],
  "6": [
   "abide by",
   "alleviate",
   "coincide",
   "compound",
   "confine",
   "derive",
   "engulf",
   "exacerbate",
   "extrapolate",
   "mitigate",
   "permeate",
   "underpin",
   "aftermath",
   "adjacent",
   "contingent on",
   "embedded",
   "feasible",
   "incumbent",
   "inherent",
   "paramount"
  ],
  "7": [
   "accentuate",
   "assert",
   "attribute to",
   "corroborate",
   "delineate",
   "demonstrate",
   "discern",
   "emphasise",
   "foreground",
   "highlight",
   "illuminate",
   "lend weight to",
   "purport",
   "reinforce",
   "underlie",
   "forefront",
   "nuance",
   "contentious",
   "disproportionate",
   "rigorous"
  ],
  "8": [
   "curriculum",
   "pedagogy",
   "competency",
   "attainment",
   "accreditation",
   "accountability",
   "equity",
   "meritocracy",
   "privatisation",
   "disengagement",
   "critical thinking",
   "autonomous learning",
   "rote learning",
   "formative assessment",
   "standardised testing",
   "inclusive education",
   "widening access",
   "well-roundedness",
   "socioeconomic",
   "vocationally"
  ],
  "9": [
   "weaponise",
   "algorithm",
   "bias",
   "clickbait",
   "content moderation",
   "disinformation",
   "misinformation",
   "echo chamber",
   "filter bubble",
   "free speech",
   "information literacy",
   "media literacy",
   "narrative",
   "platform",
   "regulation",
   "source verification",
   "surveillance capitalism",
   "transparency",
   "watchdog",
   "viral"
  ],
  "10": [
   "acquit",
   "indict",
   "allegation",
   "culpability",
   "liability",
   "verdict",
   "statute",
   "jurisdiction",
   "extradition",
   "immunity",
   "sovereignty",
   "testimonial",
   "retribution",
   "civil liberties",
   "due process",
   "presumption of innocence",
   "restorative justice",
   "arbitrary",
   "compensatory",
   "wrongful"
  ],
  "11": [
   "accountability",
   "autocracy",
   "bureaucracy",
   "coalition",
   "consensus",
   "constituency",
   "demagogue",
   "electorate",
   "geopolitics",
   "incumbent",
   "mandate",
   "polarisation",
   "populism",
   "sovereignty",
   "technocracy",
   "transparency",
   "veto",
   "checks and balances",
   "proportional representation",
   "bipartisan"
  ],
  "12": [
   "anchoring",
   "priming",
   "framing effect",
   "default",
   "heuristic",
   "nudge",
   "overconfidence",
   "willpower",
   "tribalism",
   "cognitive bias",
   "confirmation bias",
   "self-serving bias",
   "status quo bias",
   "unconscious bias",
   "loss aversion",
   "ego depletion",
   "sunk cost fallacy",
   "behavioural economics",
   "rational choice",
   "System 1 / System 2"
  ],
  "13": [
   "pedestrianise",
   "commute",
   "displacement",
   "densification",
   "gentrification",
   "infrastructure",
   "liveability",
   "regeneration",
   "resilience",
   "segregation",
   "sprawl",
   "zoning",
   "affordable housing",
   "brownfield",
   "green space",
   "mixed-use development",
   "public realm",
   "smart city",
   "social cohesion",
   "urban heat island"
  ],
  "14": [
   "austerity",
   "deflation",
   "inflation",
   "tariff",
   "remittances",
   "redistribution",
   "protectionism",
   "GDP",
   "Gini coefficient",
   "capital flight",
   "debt servicing",
   "fiscal policy",
   "monetary policy",
   "labour market",
   "foreign direct investment",
   "free trade",
   "comparative advantage",
   "trickle-down economics",
   "bilateral",
   "multilateral"
  ],
  "15": [
   "autonomy",
   "beneficence",
   "non-maleficence",
   "comorbidity",
   "determinant",
   "malpractice",
   "pandemic",
   "triage",
   "clinical trial",
   "informed consent",
   "herd immunity",
   "vaccine hesitancy",
   "palliative care",
   "preventive medicine",
   "public health",
   "universal healthcare",
   "equitable access",
   "evidence-based medicine",
   "genetic determinism",
   "pharmaceutical"
  ],
  "16": [
   "absolutism",
   "altruism",
   "consequentialism",
   "deontology",
   "utilitarianism",
   "virtue ethics",
   "hedonism",
   "eudaimonia",
   "moral relativism",
   "nihilism",
   "existentialism",
   "empiricism",
   "rationalism",
   "pragmatism",
   "determinism",
   "fallibilism",
   "teleology",
   "free will",
   "social contract",
   "categorical imperative"
  ],
  "17": [
   "accent",
   "dialect",
   "vernacular",
   "mother tongue",
   "heritage language",
   "lingua franca",
   "register",
   "bilingualism",
   "multilingualism",
   "diglossia",
   "code-switching",
   "translanguaging",
   "endangered language",
   "language death",
   "prestige variety",
   "standardisation",
   "framing",
   "linguistic relativity",
   "sociolinguistics",
   "stigmatised"
  ],
  "18": [
   "biodiversity",
   "carbon footprint",
   "carbon capture",
   "carbon neutrality",
   "decarbonisation",
   "net zero",
   "zero waste",
   "fossil fuels",
   "renewable energy",
   "circular economy",
   "climate justice",
   "intergenerational equity",
   "ecosystem services",
   "emissions trading",
   "greenwashing",
   "Paris Agreement",
   "precautionary principle",
   "resilience",
   "tipping point",
   "transition"
  ],
  "19": [
   "doping",
   "amateurism",
   "professionalisation",
   "commercialisation",
   "elite athlete",
   "high-performance sport",
   "spectator sport",
   "talent pathway",
   "fan culture",
   "legacy",
   "physiology",
   "wellbeing",
   "identity",
   "inclusivity",
   "gender equality",
   "meritocracy",
   "nationalism",
   "tribalism",
   "soft power",
   "sportswashing"
  ],
  "20": [
   "asylum seeker",
   "refugee",
   "diaspora",
   "displacement",
   "remittances",
   "host country",
   "acculturation",
   "assimilation",
   "integration",
   "belonging",
   "marginalisation",
   "othering",
   "xenophobia",
   "multiculturalism",
   "cosmopolitanism",
   "intersectionality",
   "cultural hybridity",
   "rootlessness",
   "stateless",
   "transnational"
  ],
  "21": [
   "agency",
   "privilege",
   "hegemony",
   "discrimination",
   "patriarchy",
   "tokenism",
   "class system",
   "social mobility",
   "upward mobility",
   "wealth gap",
   "structural inequality",
   "systemic racism",
   "equality of opportunity",
   "meritocracy",
   "cultural capital",
   "social reproduction",
   "symbolic violence",
   "dominant ideology",
   "power dynamics",
   "intersectionality"
  ],
  "22": [
   "protagonist",
   "characterisation",
   "narrative voice",
   "unreliable narrator",
   "counter-narrative",
   "worldbuilding",
   "foreshadowing",
   "subtext",
   "allegory",
   "metaphor",
   "symbolism",
   "canon",
   "intertextuality",
   "defamiliarisation",
   "ambiguity",
   "empathy",
   "ideology",
   "realism",
   "verisimilitude",
   "postcolonial"
  ],
  "23": [
   "automation",
   "algorithmic bias",
   "artificial general intelligence",
   "machine learning",
   "deep learning",
   "generative AI",
   "natural language processing",
   "black box",
   "singularity",
   "data privacy",
   "intellectual property",
   "job displacement",
   "universal basic income",
   "value alignment",
   "disinformation",
   "regulation",
   "surveillance capitalism",
   "transparency",
   "existential risk",
   "ethical AI"
  ],
  "24": [
   "abstraction",
   "ambivalence",
   "asymmetry",
   "coherence",
   "contingency",
   "determinism",
   "dichotomy",
   "discourse",
   "fallacy",
   "hypothesis",
   "implication",
   "inference",
   "legitimacy",
   "nuance",
   "paradigm",
   "precedent",
   "reductionism",
   "synthesis",
   "epistemic",
   "hegemonic"
  ],
  "25": [
   "articulate",
   "circumvent",
   "compel",
   "concede",
   "conflate",
   "contend",
   "contextualise",
   "delineate",
   "discern",
   "disentangle",
   "elucidate",
   "encapsulate",
   "enumerate",
   "eradicate",
   "interrogate",
   "invoke",
   "permeate",
   "substantiate",
   "caveat",
   "nuanced"
  ],
  "26": [
   "acknowledge",
   "challenge",
   "clarify",
   "elaborate",
   "interrupt",
   "undermine",
   "assertion",
   "concession",
   "counterargument",
   "premise",
   "rebuttal",
   "thesis",
   "burden of proof",
   "dilemma",
   "rhetoric",
   "signpost",
   "fallacious",
   "non sequitur",
   "red herring",
   "straw man"
  ],
  "27": [
   "annotate",
   "paraphrase",
   "proofread",
   "abstract",
   "bibliography",
   "citation",
   "counterpoint",
   "draft",
   "evidence",
   "executive summary",
   "introduction",
   "plagiarism",
   "precision",
   "register",
   "revision",
   "essay plan",
   "thesis statement",
   "topic sentence",
   "body paragraph",
   "hook",
   "argument structure"
  ],
  "28": [
   "allude to",
   "amount to",
   "bear out",
   "bring to bear",
   "call into question",
   "come to terms with",
   "cut across",
   "draw on",
   "fall short of",
   "give rise to",
   "hinge on",
   "lay bare",
   "make the case for",
   "mitigate",
   "play out",
   "point to",
   "rest on",
   "shed light on",
   "stand up to",
   "underpin"
  ],
  "29": [
   "calibrate",
   "consolidate",
   "converge",
   "embody",
   "extrapolate",
   "habituate",
   "integrate",
   "internalise",
   "refine",
   "synthesise",
   "acumen",
   "breadth",
   "depth",
   "discernment",
   "metacognition",
   "repertoire",
   "rigour",
   "scope",
   "overarching",
   "transferable"
  ],
  "30": [
   "cultivate",
   "achievement",
   "aspiration",
   "capacity",
   "dedication",
   "eloquence",
   "foundation",
   "growth",
   "horizon",
   "journey",
   "mastery",
   "milestone",
   "perseverance",
   "potential",
   "precision",
   "readiness",
   "transformation",
   "accomplished",
   "articulate",
   "intellectual"
  ]
 },
 "C1": {
  "1": [
   "adjudicate",
   "ameliorate",
   "bifurcate",
   "circumscribe",
   "codify",
   "elide",
   "antecedent",
   "axiom",
   "counterfactual",
   "dissonance",
   "empiricism",
   "exegesis",
   "extrapolation",
   "fiduciary",
   "genealogy",
   "canonical",
   "commensurate",
   "contiguous",
   "deontological",
   "dialectical"
  ],
  "2": [
   "adumbrate",
   "attenuate",
   "augment",
   "confound",
   "deracinate",
   "apotheosis",
   "apposition",
   "chiasmus",
   "cosmology",
   "culpability",
   "abstruse",
   "arcane",
   "apposite",
   "atavistic",
   "auxiliary",
   "collateral",
   "commensurable",
   "constitutive",
   "contentious",
   "caveat emptor"
  ],
  "3": [
   "aver",
   "beguile",
   "belabour",
   "broach",
   "cavil",
   "alacrity",
   "aphorism",
   "approbation",
   "aspersion",
   "attrition",
   "bellwether",
   "cadence",
   "censure",
   "acerbic",
   "adroit",
   "anodyne",
   "antithetical",
   "apposite",
   "assiduous",
   "brazen"
  ],
  "4": [
   "bilateralism",
   "brinkmanship",
   "compellence",
   "conditionality",
   "constructivism",
   "détente",
   "extraterritoriality",
   "geopolitics",
   "hegemony",
   "irredentism",
   "legitimacy",
   "multilateralism",
   "realpolitik",
   "sovereignty",
   "transactionalism",
   "balkanisation",
   "asymmetric",
   "westphalian",
   "bellicose",
   "systemic risk"
  ],
  "5": [
   "behaviourism",
   "cogito",
   "dualism",
   "eliminativism",
   "epiphenomenalism",
   "functionalism",
   "intentionality",
   "monism",
   "panpsychism",
   "phenomenology",
   "physicalism",
   "qualia",
   "reductionism",
   "supervenience",
   "the hard problem",
   "zombie",
   "representationalism",
   "dialectical",
   "deflationary",
   "higher-order"
  ],
  "6": [
   "internalise",
   "adverse selection",
   "allocative efficiency",
   "asymmetric information",
   "Coase theorem",
   "deadweight loss",
   "externality",
   "game theory",
   "market failure",
   "moral hazard",
   "natural monopoly",
   "Pareto optimality",
   "pigouvian tax",
   "principal-agent problem",
   "public good",
   "regulatory capture",
   "rent-seeking",
   "systemic risk",
   "welfare economics",
   "Keynesian"
  ],
  "7": [
   "decolonise",
   "subaltern",
   "orientalism",
   "epistemic violence",
   "hybridity",
   "mimicry",
   "coloniality",
   "hegemony",
   "diaspora",
   "othering",
   "settler colonialism",
   "episteme",
   "agency",
   "Eurocentrism",
   "subaltern studies",
   "Fanon",
   "negritude",
   "intersectionality",
   "decolonial",
   "postcolonial"
  ],
  "8": [
   "patriarchy",
   "performativity",
   "heteronormativity",
   "intersectionality",
   "second-wave feminism",
   "queer theory",
   "the male gaze",
   "essentialism",
   "gender binary",
   "liberal feminism",
   "radical feminism",
   "standpoint epistemology",
   "care ethics",
   "gendered labour",
   "embodiment",
   "glass ceiling",
   "reproductive justice",
   "sexism",
   "misogyny",
   "reproductive rights"
  ],
  "9": [
   "historiography",
   "collective memory",
   "counterfactual",
   "presentism",
   "teleology",
   "contingency",
   "commemorative",
   "archive",
   "lieux de mémoire",
   "palimpsest",
   "transitional justice",
   "anachronism",
   "revisionism",
   "subaltern history",
   "postmemory",
   "heritage",
   "myth",
   "trauma",
   "monument",
   "memory studies"
  ],
  "10": [
   "falsifiability",
   "paradigm",
   "paradigm shift",
   "induction",
   "deduction",
   "epistemology",
   "empiricism",
   "rationalism",
   "underdetermination",
   "a priori",
   "a posteriori",
   "realism",
   "instrumentalism",
   "anomaly",
   "theory-ladenness",
   "demarcation problem",
   "positivism",
   "scientific revolution",
   "verificationism",
   "inference to the best explanation"
  ],
  "11": [
   "paradigm shift",
   "peer review",
   "techno-determinism",
   "algorithmic bias",
   "surveillance capitalism",
   "replication crisis",
   "transhumanism",
   "digital divide",
   "open science",
   "biosecurity",
   "precautionary principle",
   "dual-use research",
   "artificial general intelligence",
   "CRISPR ethics",
   "net neutrality",
   "right to be forgotten",
   "information asymmetry",
   "scientism",
   "techno-utopianism"
  ],
  "12": [
   "agenda-setting",
   "framing",
   "echo chamber",
   "disinformation",
   "the public sphere",
   "spin",
   "gatekeeping",
   "propaganda",
   "media literacy",
   "manufactured consent",
   "soft power",
   "mediatisation",
   "spectacle",
   "credibility",
   "infodemic",
   "filter bubble",
   "post-truth",
   "fourth estate",
   "chilling effect"
  ],
  "13": [
   "gentrification",
   "spatial justice",
   "heterotopia",
   "urban sprawl",
   "right to the city",
   "defensible space",
   "the panopticon",
   "placemaking",
   "creative destruction",
   "public realm",
   "mixed-use development",
   "megacity",
   "NIMBY",
   "smart city",
   "informal settlements",
   "contested space",
   "walkability",
   "third place"
  ],
  "14": [
   "habitus",
   "cultural capital",
   "subculture",
   "politics of recognition",
   "symbolic violence",
   "multiculturalism",
   "identity politics",
   "essentialism (cultural)",
   "assimilation",
   "difference",
   "cosmopolitanism",
   "cultural hegemony",
   "the culture industry",
   "popular culture",
   "decoding",
   "bricolage",
   "cultural relativism",
   "canon",
   "hybridisation",
   "discourse"
  ],
  "15": [
   "jus cogens",
   "sovereignty",
   "the responsibility to protect",
   "humanitarian intervention",
   "universal jurisdiction",
   "erga omnes",
   "distributive justice (global)",
   "non-refoulement",
   "customary international law",
   "transitional justice",
   "legal positivism",
   "natural law",
   "cosmopolitan justice",
   "realism (international relations)",
   "constructivism (IR)",
   "ICC",
   "obligation to prosecute",
   "extraterritoriality",
   "human security",
   "lex specialis"
  ],
  "16": [
   "critical discourse analysis",
   "speech act",
   "linguistic relativity",
   "pragmatics",
   "presupposition",
   "euphemism",
   "register",
   "code-switching",
   "metalanguage",
   "language policy",
   "discourse",
   "ideology (linguistic)",
   "the linguistic turn",
   "naming and framing",
   "intertextuality",
   "performative utterance",
   "signifier/signified",
   "language endangerment",
   "rhetoric",
   "linguistic landscape",
   "doublespeak"
  ],
  "17": [
   "secularisation",
   "the sacred and the profane",
   "fundamentalism",
   "laïcité",
   "theodicy",
   "religious pluralism",
   "civil religion",
   "charisma",
   "disenchantment",
   "liberation theology",
   "religious nationalism",
   "post-secular",
   "spirituality",
   "hermeneutics",
   "religious experience",
   "syncretism",
   "new religious movements",
   "interfaith dialogue",
   "the return of religion"
  ],
  "18": [
   "aesthetics",
   "mimesis",
   "the sublime",
   "catharsis",
   "the death of the author",
   "kitsch",
   "avant-garde",
   "institutional theory of art",
   "hermeneutics (of art)",
   "aesthetic disinterestedness",
   "expressivism",
   "formalism (art)",
   "postmodern aesthetics",
   "aura",
   "camp",
   "the uncanny",
   "the gaze (aesthetic)",
   "aesthetic experience",
   "criticism vs interpretation"
  ],
  "19": [
   "bioethics",
   "autonomy (medical)",
   "non-maleficence",
   "beneficence",
   "informed consent",
   "euthanasia",
   "environmental ethics",
   "deep ecology",
   "intergenerational justice",
   "the precautionary principle",
   "designer babies",
   "enhancement ethics",
   "trolley problem",
   "the ethics of care",
   "animal rights",
   "climate justice",
   "slippery slope",
   "the right to die",
   "distributive justice (health)",
   "moral enhancement"
  ],
  "20": [
   "asylum seeker",
   "non-refoulement",
   "statelessness",
   "diaspora",
   "jus soli / jus sanguinis",
   "open borders",
   "integration",
   "xenophobia",
   "brain drain",
   "transmigration",
   "managed migration",
   "internally displaced persons",
   "cosmopolitanism",
   "detention",
   "safe country of origin",
   "irregular migration",
   "multiculturalism",
   "push and pull factors",
   "remittances"
  ],
  "21": [
   "imagined community",
   "primordialism",
   "ethnonationalism",
   "civic nationalism",
   "self-determination",
   "irredentism",
   "diaspora nationalism",
   "methodological nationalism",
   "banal nationalism",
   "separatism",
   "sovereignty",
   "minority rights",
   "constitutional patriotism",
   "nationalism",
   "statecraft",
   "genocide",
   "federalism",
   "territorial integrity",
   "post-nationalism",
   "state formation"
  ],
  "22": [
   "deliberative democracy",
   "populism",
   "democratic backsliding",
   "competitive authoritarianism",
   "illiberal democracy",
   "majoritarianism",
   "checks and balances",
   "plebiscitary democracy",
   "civil society",
   "elite capture",
   "political polarisation",
   "technocracy",
   "constitutional crisis",
   "democratic erosion",
   "norms",
   "veto players",
   "electoral integrity",
   "democratic consolidation",
   "accountability"
  ],
  "23": [
   "realism",
   "liberalism (IR)",
   "constructivism (IR)",
   "hegemony",
   "multilateralism",
   "soft power",
   "deterrence",
   "norm entrepreneur",
   "the security dilemma",
   "collective security",
   "sphere of influence",
   "humanitarian intervention",
   "geopolitics",
   "alliance",
   "sanctions",
   "responsibility to protect",
   "polarity",
   "power transition theory",
   "non-state actors"
  ],
  "24": [
   "qualia",
   "phenomenal consciousness",
   "functionalism",
   "physicalism",
   "dualism",
   "eliminativism",
   "intentionality",
   "epiphenomenalism",
   "higher-order theory",
   "personal identity",
   "free will",
   "metacognition",
   "the binding problem",
   "introspection",
   "panpsychism",
   "zombie argument",
   "extended mind",
   "embodied cognition",
   "the Mary problem",
   "representationalism"
  ],
  "25": [
   "jurisprudence",
   "natural law",
   "legal positivism",
   "rule of law",
   "due process",
   "habeas corpus",
   "judicial review",
   "distributive justice",
   "restorative justice",
   "retributivism",
   "universal jurisdiction",
   "jus cogens",
   "proportionality",
   "non-derogable rights",
   "international humanitarian law",
   "accountability",
   "legal pluralism",
   "legitimate expectation",
   "subsidiarity",
   "erga omnes"
  ],
  "26": [
   "algorithmic bias",
   "surveillance capitalism",
   "digital divide",
   "data sovereignty",
   "platform economy",
   "explainability",
   "net neutrality",
   "deepfake",
   "digital rights",
   "techno-solutionism",
   "right to be forgotten",
   "dark pattern",
   "digital authoritarianism",
   "content moderation",
   "AI alignment",
   "epistemic autonomy",
   "technological unemployment",
   "information warfare",
   "open source",
   "biometric surveillance"
  ],
  "27": [
   "market failure",
   "externality",
   "rent-seeking",
   "Keynesian economics",
   "neoliberalism",
   "fiscal policy",
   "monetary policy",
   "comparative advantage",
   "inequality",
   "austerity",
   "public good",
   "regulatory capture",
   "monopoly power",
   "predistribution",
   "financialisation",
   "moral hazard",
   "Gini coefficient",
   "Pigouvian tax",
   "paradox of thrift",
   "oligopoly"
  ],
  "28": [
   "anthropogenic",
   "carbon budget",
   "tipping point",
   "carbon capture",
   "biodiversity",
   "ecosystem services",
   "decarbonisation",
   "climate justice",
   "carbon trading",
   "planetary boundaries",
   "loss and damage",
   "just transition",
   "greenwashing",
   "net zero",
   "adaptation",
   "geoengineering",
   "ecological footprint",
   "Paris Agreement",
   "degrowth",
   "stranded assets",
   "carbon neutrality"
  ],
  "29": [
   "informed consent",
   "autonomy",
   "CRISPR",
   "triage",
   "pandemic preparedness",
   "herd immunity",
   "bioethics",
   "equity in health",
   "placebo effect",
   "euthanasia",
   "gene therapy",
   "antimicrobial resistance",
   "epigenetics",
   "social determinants of health",
   "clinical trial",
   "health disparities",
   "pharmaceutical pricing",
   "evidence-based medicine",
   "organ allocation",
   "public health paternalism"
  ],
  "30": [
   "disinformation",
   "echo chamber",
   "media literacy",
   "framing effect",
   "fourth estate",
   "post-truth",
   "agenda-setting",
   "watchdog journalism",
   "propaganda",
   "investigative journalism",
   "filter bubble",
   "journalistic objectivity",
   "media concentration",
   "source credibility",
   "chilling effect",
   "public interest",
   "media pluralism",
   "networked journalism",
   "prebunking",
   "information overload"
  ],
  "31": [
   "gentrification",
   "urban sprawl",
   "public space",
   "mixed-use development",
   "zoning",
   "urban density",
   "right to the city",
   "placemaking",
   "smart city",
   "housing affordability",
   "urban heat island",
   "architectural criticism",
   "walkability",
   "displacement",
   "infrastructure",
   "heritage conservation",
   "transit-oriented development",
   "spatial justice",
   "participatory planning",
   "defensible space"
  ],
  "32": [
   "cognitive bias",
   "confirmation bias",
   "nudge theory",
   "heuristic",
   "social proof",
   "loss aversion",
   "priming",
   "obedience to authority",
   "conformity",
   "intrinsic motivation",
   "cognitive dissonance",
   "fundamental attribution error",
   "self-fulfilling prophecy",
   "stereotype threat",
   "metacognition",
   "behavioural economics",
   "placebo effect",
   "emotional regulation",
   "theory of mind",
   "resilience"
  ],
  "33": [
   "discourse analysis",
   "intertextuality",
   "narrative",
   "rhetoric",
   "semiotics",
   "deconstruction",
   "metaphor",
   "postcolonial criticism",
   "unreliable narrator",
   "canon",
   "genre",
   "ambiguity",
   "close reading",
   "ideology",
   "allegory",
   "stream of consciousness",
   "the uncanny",
   "syntax",
   "literary theory"
  ],
  "34": [
   "historiography",
   "collective memory",
   "transitional justice",
   "historical revisionism",
   "commemoration",
   "oral history",
   "Eurocentrism",
   "counterfactual history",
   "primary source",
   "genocide",
   "historical analogy",
   "nationalism",
   "empire",
   "trauma",
   "periodisation",
   "reparations",
   "archives",
   "the politics of memory",
   "anachronism"
  ],
  "35": [
   "falsifiability",
   "paradigm shift",
   "empiricism",
   "peer review",
   "replication crisis",
   "scientific consensus",
   "epistemology",
   "inductive reasoning",
   "Occam's razor",
   "theory-ladenness",
   "underdetermination",
   "social construction",
   "expertise",
   "confirmation bias",
   "abductive reasoning",
   "pseudoscience",
   "scientific realism",
   "methodological pluralism",
   "knowledge commons",
   "epistemic injustice"
  ]
 },
 "C2": {
  "1": [
   "equivocate",
   "fulminate",
   "vituperate",
   "efface",
   "circumlocution",
   "tenderness",
   "pellucid",
   "limpid",
   "inscrutable",
   "recondite",
   "laconic",
   "garrulous",
   "tendentious",
   "sycophantic",
   "trenchant",
   "meretricious",
   "nugatory",
   "fastidious",
   "inimitable",
   "portentous"
  ],
  "2": [
   "equanimity",
   "lacuna",
   "whimsy",
   "gravitas",
   "sardonic",
   "wry",
   "mordant",
   "acerbic",
   "droll",
   "ambivalent",
   "sanguine",
   "rueful",
   "insouciant",
   "lugubrious",
   "melancholic",
   "lachrymose",
   "bathetic",
   "irascible",
   "valedictory",
   "venerable"
  ],
  "3": [
   "the mind-body problem",
   "dualism",
   "physicalism",
   "functionalism",
   "epiphenomenalism",
   "eliminativism",
   "reductionism",
   "supervenience",
   "emergence",
   "qualia",
   "phenomenal consciousness",
   "the hard problem",
   "zombies (philosophical)",
   "intentionality",
   "stream of consciousness",
   "self-consciousness",
   "apperception",
   "personal identity",
   "narrative identity",
   "the Chinese Room",
   "the Turing test"
  ],
  "4": [
   "discourse",
   "power/knowledge",
   "governmentality",
   "biopolitics",
   "discipline",
   "the panopticon",
   "hegemony",
   "counter-hegemony",
   "ideology",
   "false consciousness",
   "reification",
   "interpellation",
   "subjectivity",
   "performativity",
   "normativity",
   "subaltern",
   "intersectionality",
   "genealogy",
   "critique",
   "praxis"
  ],
  "5": [
   "mimesis",
   "catharsis",
   "the sublime",
   "the uncanny",
   "negative capability",
   "defamiliarisation",
   "ekphrasis",
   "affect",
   "jouissance",
   "the death of the author",
   "intertextuality",
   "heteroglossia",
   "the readerly and writerly text",
   "close reading",
   "the hermeneutic circle",
   "aporia",
   "logocentrism",
   "the canon",
   "écriture féminine",
   "the gaze"
  ],
  "6": [
   "deontology",
   "consequentialism",
   "virtue ethics",
   "contractarianism",
   "care ethics",
   "the categorical imperative",
   "the trolley problem",
   "the principle of double effect",
   "the demandingness objection",
   "the separateness of persons",
   "the veil of ignorance",
   "moral luck",
   "moral realism",
   "moral sentimentalism",
   "moral particularism",
   "the is-ought problem",
   "phronesis",
   "autonomy",
   "integrity"
  ],
  "7": [
   "arbitrariness of the sign",
   "langue and parole",
   "metalanguage",
   "reference and sense",
   "truth-conditional semantics",
   "prototype theory",
   "pragmatics",
   "deixis",
   "presupposition",
   "implicature",
   "the cooperative principle",
   "speech act theory",
   "performative utterances",
   "Wittgenstein's language games",
   "the private language argument",
   "the linguistic turn",
   "the Sapir-Whorf hypothesis",
   "the Whorfian hypothesis revisited",
   "code-switching"
  ],
  "8": [
   "the Enlightenment",
   "Romanticism",
   "positivism",
   "dialectic",
   "the Frankfurt School",
   "structuralism",
   "post-structuralism",
   "phenomenology",
   "pragmatism",
   "hermeneutics",
   "zeitgeist",
   "the sociology of knowledge",
   "intellectual genealogy",
   "Foucauldian archaeology",
   "the linguistic turn (in history)",
   "Begriffsgeschichte",
   "intellectual history vs history of ideas",
   "anachronism",
   "the canon of Western philosophy"
  ],
  "9": [
   "sovereignty",
   "the social contract",
   "the general will",
   "legitimacy",
   "political obligation",
   "civil disobedience",
   "the rule of law",
   "deliberative democracy",
   "agonistic democracy",
   "republicanism",
   "communitarianism",
   "cosmopolitanism",
   "liberal nationalism",
   "statelessness",
   "distributive justice",
   "the original position",
   "the capabilities approach",
   "global justice",
   "toleration",
   "the harm principle"
  ],
  "10": [
   "falsifiability",
   "the demarcation problem",
   "underdetermination",
   "scientific realism",
   "the structure of scientific revolutions",
   "paradigm shift",
   "incommensurability",
   "the replication crisis",
   "scientism",
   "post-normal science",
   "normative vs descriptive in science",
   "the sociology of scientific knowledge",
   "expertise",
   "technocracy",
   "epistemic injustice",
   "citizen science",
   "the precautionary principle",
   "algorithmic governance",
   "technological determinism",
   "transhumanism"
  ],
  "11": [
   "the invisible hand",
   "comparative advantage",
   "the profit motive",
   "market failure",
   "externality",
   "rent-seeking",
   "moral hazard",
   "Keynesian economics",
   "neoliberalism",
   "austerity",
   "trickle-down economics",
   "the Laffer curve",
   "financialisation",
   "financialised capitalism",
   "creative destruction",
   "the Gini coefficient",
   "heterodox economics",
   "primitive accumulation",
   "post-scarcity"
  ],
  "12": [
   "metacognition",
   "cognitive bias",
   "cognitive dissonance",
   "self-deception",
   "the adaptive unconscious",
   "introspection",
   "theory of mind",
   "affect",
   "emotional regulation",
   "rumination",
   "the hedonic treadmill",
   "the ego and its defences",
   "attachment theory",
   "resilience",
   "existential anxiety",
   "the embodied mind",
   "the dialogic self",
   "narrative identity",
   "the self as construction"
  ],
  "13": [
   "the Anthropocene",
   "anthropocentrism",
   "deep ecology",
   "the land ethic",
   "biodiversity",
   "the sixth mass extinction",
   "carbon footprint",
   "the tragedy of the commons",
   "ecocide",
   "the polluter pays principle",
   "rewilding",
   "geoengineering",
   "sustainable development",
   "degrowth",
   "intergenerational justice",
   "climate justice",
   "environmental racism",
   "ecological grief",
   "climate grief"
  ],
  "14": [
   "the implied author",
   "the unreliable narrator",
   "free indirect discourse",
   "narrative closure",
   "the picaresque",
   "the bildungsroman",
   "the novel of ideas",
   "magical realism",
   "the lyric essay",
   "trauma literature",
   "world literature",
   "the grotesque",
   "the sublime",
   "catharsis",
   "defamiliarisation",
   "intertextuality",
   "ekphrasis",
   "close reading",
   "the ethics of reading"
  ],
  "15": [
   "habitus",
   "field (champ)",
   "social capital",
   "cultural capital",
   "symbolic violence",
   "social stratification",
   "social mobility",
   "meritocracy",
   "intersectionality",
   "the social construction of reality",
   "impression management",
   "the stranger",
   "total institution",
   "anomie",
   "the iron cage",
   "the civilising process",
   "moral panic",
   "the public sphere"
  ],
  "16": [
   "world-systems theory",
   "settler colonialism",
   "cultural imperialism",
   "Orientalism",
   "the colonial gaze",
   "the contact zone",
   "hybridity",
   "mimicry (colonial)",
   "the subaltern",
   "the native informant",
   "epistemic injustice (postcolonial)",
   "decolonisation",
   "nativism",
   "négritude",
   "Fanon and the wretched of the earth",
   "Frantz Fanon on the colonial subject",
   "diaspora",
   "postcolonial melancholia"
  ],
  "17": [
   "fourth estate",
   "gatekeeping (media)",
   "agenda-setting",
   "media framing",
   "manufacturing consent",
   "the spiral of silence",
   "the CNN effect",
   "the public sphere",
   "the network society",
   "the spectacle (Debord)",
   "the attention economy",
   "platform capitalism",
   "algorithmic curation",
   "filter bubble",
   "disinformation vs misinformation",
   "post-truth",
   "astroturfing",
   "deepfakes",
   "media literacy"
  ],
  "18": [
   "mimesis",
   "catharsis",
   "the sublime",
   "the uncanny (unheimlich)",
   "aesthetic experience",
   "aesthetic judgement",
   "aesthetic autonomy",
   "aesthetic moralism vs autonomism",
   "formalism (aesthetics)",
   "defamiliarisation (ostranenie)",
   "the death of the author",
   "ekphrasis",
   "the avant-garde",
   "the readymade",
   "the institutional theory of art",
   "the Gesamtkunstwerk",
   "kitsch",
   "representation and politics",
   "the culture industry"
  ],
  "19": [
   "natural law vs legal positivism",
   "legal realism",
   "legal pluralism",
   "the social contract (Locke, Rousseau, Hobbes)",
   "the veil of ignorance",
   "the rule of law",
   "the separation of powers",
   "judicial review",
   "due process",
   "habeas corpus",
   "the reasonable person standard",
   "proportionality (law)",
   "the right to freedom of expression",
   "civil disobedience",
   "restorative vs retributive justice",
   "international humanitarian law",
   "jus cogens",
   "universal jurisdiction"
  ],
  "20": [
   "the politics of recognition",
   "recognition vs redistribution",
   "multiculturalism",
   "essentialism vs constructivism (identity)",
   "performativity (Butler)",
   "intersectionality",
   "subaltern identity politics",
   "queer theory",
   "whiteness studies",
   "ableism",
   "the unmarked norm",
   "epistemic privilege",
   "tokenism",
   "affirmative action",
   "the veil (hijab debates)",
   "the politics of solidarity",
   "the politics of shame and pride",
   "cosmopolitanism vs nationalism",
   "the right to be forgotten"
  ],
  "21": [
   "comparative advantage",
   "free trade vs protectionism",
   "trade deficit vs surplus",
   "global supply chains",
   "neoliberal globalisation",
   "deglobalisation",
   "the Washington Consensus",
   "the Bretton Woods system",
   "the global reserve currency",
   "currency wars",
   "the trilemma (impossible trinity)",
   "the resource curse",
   "financialisation",
   "sovereign debt crisis",
   "offshore finance",
   "intellectual property rights (IPR)",
   "the Gini coefficient",
   "climate economics"
  ],
  "22": [
   "timbre",
   "rhythm and metre",
   "tonality vs atonality",
   "heterophony / polyphony / homophony",
   "counterpoint",
   "spectralism",
   "absolute music vs programme music",
   "the musical work",
   "musical improvisation",
   "the acousmatic",
   "noise vs music",
   "the soundscape",
   "the phonograph effect",
   "music and affect",
   "the politics of listening",
   "the canon (musical)",
   "musica mundana / musica humana",
   "the auteur in popular music",
   "world music (and its critiques)"
  ],
  "23": [
   "collective memory",
   "postmemory",
   "the generation of memory",
   "sites of memory (lieux de mémoire)",
   "the archive",
   "nostalgia vs memory",
   "memory and identity",
   "trauma studies",
   "testimony and witness",
   "silence and the unspeakable",
   "genocide studies",
   "transitional justice",
   "reparations",
   "the right to truth",
   "the politics of apology",
   "the duty to remember (devoir de mémoire)",
   "memory laws",
   "historical revisionism"
  ],
  "24": [
   "the natural lifespan",
   "the dying process",
   "palliative care",
   "the good death",
   "ars moriendi",
   "the Epicurean argument",
   "Being-towards-death (Sein-zum-Tode)",
   "mortality and meaning",
   "mortality salience",
   "terror management theory",
   "the death taboo",
   "grief and mourning",
   "the philosophy of grief",
   "the philosophy of suicide",
   "eschatology",
   "the afterlife and personal identity",
   "legacy and symbolic immortality",
   "the demography of death",
   "Tolstoy's Ivan Ilyich"
  ],
  "25": [
   "eros, philia, agape, storge",
   "Plato's Symposium and the ladder of beauty",
   "erotic love vs friendship love",
   "the philosophy of friendship",
   "love and recognition",
   "jealousy and possessiveness",
   "vulnerability and intimacy",
   "attachment theory",
   "long-term relationships and the problem of familiarity",
   "the ethics of care",
   "care and dependency",
   "love and moral partiality",
   "love and knowledge",
   "romantic love and autonomy",
   "the sociology of romantic love",
   "the commodification of intimacy",
   "polyamory and relationship pluralism",
   "consent and intimate ethics",
   "love in an age of digital mediation"
  ],
  "26": [
   "Hannah Arendt's labour/work/action",
   "division of labour",
   "craft and skill",
   "vocation",
   "the Protestant work ethic",
   "meaningful work",
   "alienated labour (Marx)",
   "emotional labour",
   "burnout",
   "the labour theory of value",
   "surplus value and exploitation",
   "the gig economy",
   "precariat",
   "labour market segmentation",
   "automation and technological unemployment",
   "universal basic income (UBI)",
   "the right to work vs the right not to work",
   "post-work"
  ],
  "27": [
   "the sacred vs the profane",
   "ritual",
   "religious experience",
   "mysticism",
   "immanence vs transcendence",
   "the philosophy of religion",
   "theodicy",
   "the sociology of religion",
   "secularisation thesis",
   "postsecularism",
   "secularism as political philosophy",
   "the return of religion",
   "religious pluralism",
   "fundamentalism",
   "the new atheism",
   "religious nationalism",
   "religion and violence",
   "liberation theology"
  ],
  "28": [
   "the demos",
   "deliberative democracy",
   "agonistic democracy",
   "democratic legitimacy",
   "the rule of law",
   "constitutional democracy vs majoritarianism",
   "the tyranny of the majority",
   "the crisis of representation",
   "populism",
   "identity politics",
   "political polarisation",
   "technocracy",
   "epistocracy",
   "democratic backsliding",
   "electoral authoritarianism",
   "competitive authoritarianism",
   "liberal international order"
  ],
  "29": [
   "machine learning and neural networks",
   "strong AI vs weak AI",
   "the Turing test",
   "the Chinese Room (Searle)",
   "the hard problem of consciousness",
   "the philosophy of mind and AI",
   "explainable AI (XAI)",
   "AI alignment",
   "algorithmic bias",
   "the ethics of autonomous weapons",
   "the singularity",
   "the existential risk debate",
   "surveillance capitalism",
   "digital colonialism",
   "AI and labour",
   "AI and democracy",
   "transhumanism",
   "what it means to be human (posthumanism)"
  ],
  "30": [
   "langue and parole (Saussure)",
   "metalanguage and objectlanguage",
   "philosophy of language (reference and meaning)",
   "speech act theory",
   "the linguistic turn",
   "Wittgenstein's language games",
   "the limits of my language (Wittgenstein)",
   "the Sapir-Whorf hypothesis",
   "linguistic relativity and colour terms",
   "hermeneutics",
   "the interpreter (hermeneutic subject)",
   "untranslatability",
   "the poetics of translation (Benjamin)",
   "the politics of translation",
   "the translator's invisibility",
   "the foreign and the familiar (defamiliarisation)",
   "code-switching",
   "language and power (Bourdieu)",
   "linguistic imperialism",
   "the mother tongue and language loss"
  ]
 }
}

/* C1 days 7-10 exist twice in the source data (same ids, different topics), so the first copies are keyed by "id|title". */
export const VOCAB_ORDER_BY_TITLE = {
  C1: {
    "7|Postcolonialism and Decolonisation": ["settler colonialism","néocolonialism","coloniality","hegemony","cultural imperialism","epistemic violence","Orientalism","subaltern","alterity","mimicry","hybridity","third space","assimilation","diaspora","negritude","decolonisation","indigenous epistemology","reparations","intersectionality","postcolonial melancholia"],
    "8|Gender, Feminism, and Intersectionality": ["patriarchy","misogyny","the male gaze","glass ceiling","wage gap","maternal penalty","structural inequality","reproductive rights","reproductive labour","gender binary","essentialism","performativity","queer theory","intersectionality","agency","second-wave feminism","third-wave feminism","the personal is political","solidarity"],
    "9|History, Memory, and Collective Narrative": ["historiography","epistemology of history","historical consciousness","teleology","contingency","anachronism","counterfactual history","long durée","historical revisionism","collective memory","the politics of memory","amnesia","trauma","testimony","commemorative practices","sites of memory","heritage","archive","palimpsest","narrative"],
    "10|Law, Justice, and Human Rights": ["jurisprudence","legal positivism","natural law","rule of law","due process","habeas corpus","presumption of innocence","judicial review","tort","mens rea","proportionality","derogation","distributive justice","restorative justice","inalienable rights","universal jurisdiction","jus cogens","erga omnes","sovereignty","amicus curiae"],
  },
}
